<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Optik" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-2">
              <router-link
                class="
                  btn btn-outline-primary btn-no-outline btn-with-icon-left
                  mt-3
                  btn-lg
                  px-0
                "
                to="/optik"
              >
                <i class="material-symbols-outlined">arrow_back</i>Kembali
              </router-link>
            </div>
          </div>

          <center>
            <h2 class="mb-5">Tebus Optik</h2>
            <h4 class="font-body text-muted mb-5">
              Silakan masukkan nomor rawat pasien di bawah ini
            </h4>
          </center>
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <div class="form-group">
                <div class="input-group input-group-lg">
                  <input
                    type="text"
                    :class="
                      'form-control form-control-lg pl-5 with-icon-left without-label ' +
                        (isError ? 'error' : '')
                    "
                    placeholder="Nomor rawat pasien"
                    v-model="no_rawat"
                    v-on:keyup.enter="() => searchPatient(String(no_rawat))"
                  />
                  <i class="material-symbols-outlined">assignment_ind</i>
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary btn-with-icon-right"
                      @click="() => searchPatient(String(no_rawat))"
                    >
                      SELANJUTNYA
                      <i class="material-symbols-outlined">chevron_right</i>
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-if="isError"
                class="card card-alert card-alert-danger card-alert-float mb-5"
              >
                <i class="material-symbols-outlined alert-icon"
                  >report_problem</i
                >
                <div class="alert-content">
                  <h4 class="alert-title">Data Rawat Tidak Ditemukan</h4>
                  <p class="alert-desc">
                    Tidak ditemukan data rawat yang sesuai dengan nomor rawat
                    yang Anda masukkan. Periksa kembali nomor rawat yang Anda
                    masukkan.
                  </p>
                </div>
                <!--a-- id="closeAlert" class="alert-close">
                            <i class="material-symbols-outlined">close</i>
                        </!--a-->
              </div>
              <div v-if="searchResult" class="card px-3 py-2">
                <div class="user-item">
                  <div class="user-avatar user-avatar-lg">
                    <img :src="'/img/user.jpg'" />
                    <div class="user-info">
                      <h4 class="user-name">{{ searchResult.nama }}</h4>
                    </div>
                  </div>
                  <span class="badge badge-success">
                    No Rawat : {{ searchResult.no_rawat }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
let rawatArray = [
  {
    nama: "Ahmad Subekti",
    no_rawat: `${new Date()
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "/")}/003`,
  },
];
let searchResult = null;
export default {
  name: "OptikTebus",
  components: {
    Navbar,
    Sidebar,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      no_rawat: `${new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "/")}/`,
      rawatArray: rawatArray,
      isError: false,
      searchResult: searchResult,
    };
  },
  methods: {
    displayResult(result) {
      this.isError = false;
      this.searchResult = result;
      //console.log(result);
      setTimeout(() => {
        window.location.href = "/#/optik/form";
      }, 1000);
    },
    displayNotFoundError() {
      this.isError = true;
      //console.log('error not found');
      setTimeout(() => {
        this.isError = false;
      }, 5000);
    },
    searchPatient(no_rawat) {
      let result = null;
      rawatArray.filter((patient) => {
        if (patient.no_rawat == no_rawat) {
          result = patient;
        }
        return patient;
      });
      if (result) {
        this.displayResult(result);
      } else {
        this.displayNotFoundError();
      }
    },
  },
};
</script>
